import Vue from "vue";
import VueRouter from "vue-router";
import login from "../views/login.vue";
import store from "../store";
import home from "../views/home.vue";
import tos from "../views/tos.vue";
import error from "../views/system-error.vue";
import empty from "../views/home-sub-contents/empty.vue";
import ProductRecords from "../views/home-sub-contents/product-records.vue";
import ProductRecordDetail from "../views/home-sub-contents/product-record-detail.vue";
import OutputCsv from "../views/home-sub-contents/csv-output.vue";
import ShipmentList from "../views/home-sub-contents/shipment_quantities.vue";
import AllOutputCsv from "../views/home-sub-contents/csv-output-all.vue";
import AccountList from "../views/account-list.vue";
import GroupList from "../views/group-list.vue";
import GroupEdit from "../views/group-edit.vue";
import AccountEdit from "../views/account-edit.vue";
import Account from "@/logic/api/account.js";
import ValueMapper from "@/logic/common/value-mapper.js";
import WorklogEdit from "../views/worklog-edit.vue";
import UnloadingEdit from "../views/unloading-edit.vue";
import ShippingEdit from "../views/shipping-edit.vue";
import SeawaterEdit from "../views/seawater-edit.vue";
import GraphSelect from "../views/home-sub-contents/graph-select.vue";
import GraphSelectUmilog from "../views/home-sub-contents/graph-select-umilog.vue";
import ExternalLink from "../views/home-sub-contents/external-link.vue";
import UmilogCsvOutput from "../views/home-sub-contents/umilog-csv-output.vue";
import UmilogCsvInput from "../views/home-sub-contents/umilog-csv-input.vue";
import OutputReport from "../views/home-sub-contents/report-output.vue";
import PredictionTool from "../views/home-sub-contents/prediction-tool.vue";
import PrefInformationList from "../views/pref-information-list.vue";
import PrefInformationEdit from "../views/pref-information-edit.vue";
import PrefInformationPreview from "../components/pref-information-edits/information-preview.vue";
import PrefCategoryList from "../views/pref-category-list.vue";
import PrefCategoryEdit from "../views/pref-category-edit.vue";
import PrefCategoryMailSettingList from "../views/pref-categorymail-list.vue";
import InformationList from "../views/information-list.vue";
import InformationEdit from "../views/information-edit.vue";
import InformationPreview from "../components/information-edits/information-preview.vue";
import CategoryList from "../views/category-list.vue";
import CategoryEdit from "../views/category-edit.vue";
import CategoryMailSettingList from "../views/categorymail-list.vue";
import UsageSituation from "../views/home-sub-contents/usage-situation.vue";
import UmilogDevicesMapOutput from "../views/home-sub-contents/umilog-devices-map-output.vue";
import QuestionList from "../views/home-sub-contents/question-list.vue";
import QuestionEdit from "../views/home-sub-contents/question-edit.vue";
import QuestionResult from "../views/home-sub-contents/question-result.vue";
import Answer from "../views/home-sub-contents/answer.vue";
import operationLog from "../views/home-sub-contents/output-operation-log.vue";
import AnswerCompleted from "../views/home-sub-contents/answer-completed.vue";

Vue.use(VueRouter);

/**
 * パスからの遷移先を定義する
 */
const routes = [
  {
    path: "",
    redirect: "/product",
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/index.html",
    redirect: "login",
  },
  {
    path: "/tos",
    name: "tos",
    component: tos,
  },
  {
    path: "/error",
    name: "error",
    component: error,
  },
  {
    path: "/",
    component: home,
    children: [
      {
        path: "",
        redirect: "product",
      },
      {
        path: "product/detail/:uid",
        component: ProductRecordDetail,
      },
      {
        path: "product",
        component: ProductRecords,
      },
      {
        path: "outputCsv/:name?/:uid?",
        component: OutputCsv,
      },
      {
        path: "shipmentList/:name?/:uid?",
        component: ShipmentList,
      },
      {
        path: "allOutputCsv",
        component: AllOutputCsv,
      },
      {
        path: "prefinformation",
        component: PrefInformationList,
      },
      {
        path: "prefinformation/:id",
        component: PrefInformationList,
      },
      {
        path: "prefinformation/edit/:uid",
        component: PrefInformationEdit,
      },
      {
        path: "prefinformation/preview/:uid",
        component: PrefInformationPreview,
      },
      {
        path: "prefcategory",
        component: PrefCategoryList,
      },
      {
        path: "prefcategory/edit/:uid",
        component: PrefCategoryEdit,
      },
      {
        path: "prefcategorymail",
        component: PrefCategoryMailSettingList,
      },
      {
        path: "information",
        component: InformationList,
      },
      {
        path: "information/:id",
        component: InformationList,
      },
      {
        path: "information/edit/:uid",
        component: InformationEdit,
      },
      {
        path: "information/preview/:uid",
        component: InformationPreview,
      },
      {
        path: "category",
        component: CategoryList,
      },
      {
        path: "category/edit/:uid",
        component: CategoryEdit,
      },
      {
        path: "categorymail",
        component: CategoryMailSettingList,
      },
      {
        path: "notice",
        component: empty,
      },
      {
        path: "sea",
        component: empty,
      },
      {
        path: "account",
        component: AccountList,
      },
      {
        path: "account/edit/:uid",
        component: AccountEdit,
      },
      {
        path: "group",
        component: GroupList,
      },
      {
        path: "group/edit/:uid",
        component: GroupEdit,
      },
      {
        path: "worklog/:id?/:mode?",
        component: WorklogEdit,
      },
      {
        path: "unloading/:bodyData?/:id?/:mode?",
        component: UnloadingEdit,
      },
      {
        path: "shipping/:bodyData?/:id?/:mode?",
        component: ShippingEdit,
      },
      {
        path: "seawater/:bodyData?/:id?/:mode?",
        component: SeawaterEdit,
      },
      {
        path: "graph/product",
        component: GraphSelect,
      },
      {
        path: "predictionTool",
        component: PredictionTool,
      },
      {
        path: "graph/umilog",
        component: GraphSelectUmilog,
      },
      {
        path: "deviceMap",
        component: UmilogDevicesMapOutput,
      },
      {
        path: "externallink",
        component: ExternalLink,
      },
      {
        path: "umilog",
        component: UmilogCsvOutput,
      },
      {
        path: "inputUmilog",
        component: UmilogCsvInput,
      },
      {
        path: "outputReport",
        component: OutputReport,
      },
      {
        path: "usage",
        component: UsageSituation,
      },
      {
        path: "question",
        component: QuestionList,
      },
      {
        path: "question/edit/:uid",
        component: QuestionEdit,
      },
      {
        path: "question/result/:uid",
        component: QuestionResult,
      },
      {
        path: "answer/completed",
        component: AnswerCompleted,
      },
      {
        path: "answer/:url",
        component: Answer,
      },
      {
        path: "operationLog",
        component: operationLog,
      },      {
        path: "*",
        redirect: "error",
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...routes,
  ],
});

/**
 * 遷移時のリダイレクトを定義する
 */
router.beforeEach((to, from, next) => {
  if (
    ValueMapper.map({
      error: true,
      login: true,
      tos: true,
    }).getOrElse(to.name, false)
  ) {
    // 対象の画面はログインしていなくてもリダイレクトさせない
    next();
    return;
  }
  // ログインしていないのならログイン画面に遷移する
  if (!Account.isSignIn(store)) {
    next({ name: "login" });
    return;
  }
  // リダイレクトせず、指定されたURLに遷移する
  next();
});

export default router;
